module.exports = __webpack_public_path__ + "images/Money.836c72796f07c44b7177faf244804551.svg";